import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/auth'
import recipes from '@/store/recipes'
import author from '@/store/author'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
      auth,
      recipes,
      author
    }
})
